import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { DoctorService } from '@app/services/doctor.service';
import { AuthenticationService } from '@app/services/authentication.service';
import { Constants } from '@app/shared-module/constants';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  submitted = false;
  emailId = '';
  password = '';
  emailIdForgetPwd = '';
  showForgetPassword = false;
  showPassword = false;

  message = 'Welcome!';

  @Output() messageEvent = new EventEmitter<string>();
  constructor(
    private router: Router,
    private loadingBar: LoadingBarService,
    private doctorService: DoctorService,
    private authenticationServ: AuthenticationService,
    private toastr: ToastrService) { }

  ngOnInit() {
    localStorage.removeItem('internallogin');
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }

  gotoRegister = () => {
    // this.router.navigate([Constants.REGISTER_DOCTOR_URL]);
    window.open(Constants.DOCTOR_REGISTRATION_URL, '_self');
  }

  login = () => {
    // console.log(this.emailId);
    // console.log(this.password);
    if (this.emailId && this.emailId.length !== 0) {
      if (this.password && this.password.length !== 0 && this.password.length > 6) {
        this.loadingBar.start();
        this.authenticationServ.login(this.emailId, this.password).subscribe(res => {
          if (res) {
            this.loadingBar.complete();
            // console.log(res);
            this.messageEvent.emit(this.message);
            this.submitted = true;
            this.router.navigate([Constants.DOCTOR_SUBSCRIPTION_URL]);
          }
        }, error => {
          this.loadingBar.complete();
          this.toastr.error(Constants.LABEL_ERROR, 'Invalid Credentials');
        });
      } else {
        this.toastr.error(Constants.LABEL_ERROR, 'Password length must be greater than 6 characters');
      }
    } else {
      this.toastr.error(Constants.LABEL_ERROR, 'Please provide valid user Id');
    }
  }

  forgotPassword = () => {
    this.showForgetPassword = true;
  }

  resetPassword = () => {
    if (this.emailIdForgetPwd.length > 0 && this.validateEmail(this.emailIdForgetPwd)) {
      this.loadingBar.start();
      this.doctorService.forgotPassword(this.emailIdForgetPwd).subscribe((res: any) => {
        // console.log(res);
        this.loadingBar.complete();
        if (res && res.message) {
          this.toastr.success(Constants.LABEL_SUCCESS, 'Password reset done successfully, please check your mail for the same');
          this.showForgetPassword = false;
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
      }, error => {
        this.loadingBar.complete();
        this.toastr.error(Constants.LABEL_ERROR, 'Password reset failed');
        this.showForgetPassword = false;
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      });
    } else {
      this.toastr.error(Constants.LABEL_ERROR, 'Invalid email id');
    }
  }

  validateEmail = (email) => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
}
